module.exports = __webpack_public_path__ + "static/media/epy_match.b53236ba.svg";